export default function TrustStrip() {
  const items = [
    { icon: 'ri-shield-check-line', label: 'Non-Toxic & Vet-Reviewed Materials' },
    { icon: 'ri-leaf-line', label: 'Biodegradable & Eco-Friendly' },
    { icon: 'ri-heart-pulse-line', label: 'Chew-Tested for Durability' },
    { icon: 'ri-flag-line', label: 'Made for Indian Pets & Climate' },
  ];

  return (
    <section className="bg-secondary-100 border-b border-secondary-200/60">
      <div className="w-full px-4 md:px-8 lg:px-12 py-5">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-2.5 px-3 py-3 bg-secondary-50 rounded-xl">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                <i className={`${item.icon} text-accent-500 text-sm`}></i>
              </div>
              <span className="text-xs md:text-sm font-semibold text-foreground-700 leading-snug">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}